<!-- MARK: Global Loader -->
<div class="spinnerContainer" *ngIf="!loaded">
    <mat-spinner class="crud-edit-loading"></mat-spinner>
</div>

<div>
    <!-- MARK: Volet filtre -->
    <!-- <app-shutter #filterShutter [name]="shutterName" (selectionChangeTrigger)="shutterSelectionChange()"></app-shutter> -->

    <!-- MARK: Filtre des écrans -->
    @if (loaded) {
        <wncm-screen-filter
            [shutterName]="shutterName"
            (filterParamsChange)="reloadPark($event)"
            [(filterParams)]="filterParams"
        >
        </wncm-screen-filter>
    }

    <!-- MARK: Eléments d'aide en haut à droite -->
    <div class="filterTriggerContainer">
        @if (globalViewMode === 0) {
            @if (canShowGuidedTour()) {
                <button
                    matTooltip="Tour guidé"
                    style="height: 40px; width: 40px; padding: 8px !important"
                    mat-icon-button
                    (click)="launchGuidedTour()"
                >
                    <mat-icon>help_outline</mat-icon>
                </button>
            }

            <mat-form-field class="orderBar">
                <mat-icon class="orderBarIcon">list</mat-icon>

                <mat-select [formControl]="groupBy" placeholder="Grouper par" class="shelfSelect">
                    <mat-option class="optionValue" [value]="null">-</mat-option>

                    @for (cat of categoriesAndTag; track $index) {
                        @if (cat.i) {
                            <mat-option class="optionValue" [value]="cat.i"
                                ><mat-icon>{{ cat.c }}</mat-icon
                                >{{ cat.n }}</mat-option
                            >
                        }
                    }
                </mat-select>
            </mat-form-field>

            <button
                mat-stroked-button
                style="margin-right: 10px; margin-left: 10px; width: 110px"
                color="primary"
                [matTooltip]="allExpandersClosed ? 'Ouvrir toutes les diffusions' : 'Fermer toutes les diffusions'"
                (click)="allExpandersClosed ? openAllExpanders() : closeAllExpanders()"
            >
                <span style="display: flex; align-items: center">
                    <ng-container *ngIf="allExpandersClosed"><mat-icon>unfold_more</mat-icon>Ouvrir</ng-container>
                    <ng-container *ngIf="!allExpandersClosed"><mat-icon>unfold_less</mat-icon>Fermer</ng-container>
                </span>
            </button>

            <button [disabled]="waiting$.value" mat-raised-button color="primary" (click)="initViewMap()">
                <mat-icon>map</mat-icon>Vue Carte
            </button>
        } @else {
            <button
                mat-stroked-button
                style="margin-right: 10px; margin-left: 10px; width: 110px"
                color="primary"
                [matTooltip]="allExpandersClosed ? 'Ouvrir toutes les diffusions' : 'Fermer toutes les diffusions'"
                (click)="allExpandersClosed ? openAllExpanders() : closeAllExpanders()"
            >
                <span style="display: flex; align-items: center">
                    @if (allExpandersClosed) {
                        <mat-icon>unfold_more</mat-icon>Ouvrir
                    } @else {
                        <mat-icon>unfold_less</mat-icon>Fermer
                    }
                </span>
            </button>
            <!-- Vue Map -->
            <button [disabled]="waiting$.value" mat-raised-button color="primary" (click)="initViewList()">
                <mat-icon>list</mat-icon>Vue Liste
            </button>
        }
    </div>

    <!-- MARK: Liste de tous les écrans -->
    @if (globalViewMode === 0) {
        <div
            class="mainLocationBaseContainer"
            *ngIf="loaded"
            #infiniteScrollParentElem
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="150"
            (scrolled)="onScroll()"
            [scrollWindow]="false"
            (window:resize)="onResize($event)"
            [alwaysCallback]="true"
        >
            <!-- ------------------------------------------------------ MARK: ECRANS WANCOM------------------------------------------------------ -->
            <div
                class="locationContainer"
                *ngIf="organizationLocations.wancoms != null && organizationLocations.wancoms?.length >= 0"
            >
                <h2 class="locationTitle"><mat-icon>room</mat-icon>Ecran(s) Wancom</h2>

                <hr />

                <div class="screenListContainer" id="screenList">
                    @for (face of organizationLocations.wancoms; track $index) {
                        <app-screen-info
                            [face]="face"
                            [poweredFaceIds]="poweredFaceIds"
                            [filterParams]="filterParams"
                            (playlistOrderChanged)="updatePlaylistOrder($event)"
                            (diffusionsDeleted)="deleteWancomDiffusion($event)"
                            (diffForScreenDeleted)="deleteWncmDiffFormScreen($event.diffusion, $event.faceId)"
                            [style.animation-delay.ms]="$index * 50"
                        ></app-screen-info>
                    }
                </div>
            </div>

            <!-- ----------------------------------------------------- MARK: ECRANS CLIENTS----------------------------------------------------- -->
            <div
                class="locationContainer"
                *ngIf="organizationLocations.clients != null && organizationLocations.clients?.length >= 0"
            >
                <ng-container *ngFor="let orgaClient of organizationLocations.clients; let index = index">
                    <h3 class="locationTitle" style="margin: 7px 0 0 15px">
                        <mat-icon>room</mat-icon><span>Ecran(s) clients</span>
                        <span class="screenType">{{ orgaClient.organizationName }}</span>
                    </h3>
                    <hr />
                    <div class="screenListContainer">
                        @for (face of orgaClient.faces; track $index) {
                            <app-screen-info
                                [face]="face"
                                [poweredFaceIds]="poweredFaceIds"
                                [filterParams]="filterParams"
                                (playlistOrderChanged)="updatePlaylistOrder($event)"
                                (diffusionsDeleted)="deleteDiffusion($event)"
                                (diffForScreenDeleted)="deleteDiffForScreen($event.diffusion, $event.faceId)"
                                [style.animation-delay.ms]="$index * 10"
                            >
                            </app-screen-info>
                        }
                    </div>
                </ng-container>

                <div *ngIf="organizationLocations.clients?.length <= 0">
                    <h2 class="noElement">Aucun écran</h2>
                </div>
            </div>

            <div
                class="locationContainer"
                *ngIf="
                    organizationLocations.clients == null && organizationLocations.wancoms == null && parkScrollLoaded
                "
            >
                <h2 class="noElement">Aucun écran</h2>
                <button
                    class="centerButton"
                    mat-stroked-button
                    *ngIf="filterParams.tags != null || filterParams.tags.length != 0"
                    (click)="clearAllFilter()"
                >
                    Réinitialiser le filtre
                </button>
            </div>

            <mat-spinner
                *ngIf="!parkScrollLoaded"
                [diameter]="60"
                style="margin: auto; margin-bottom: 15px"
            ></mat-spinner>
        </div>
    } @else {
        <!-- MARK: Vue MAP -->
        <div class="mainLocationBaseContainer">
            <google-map
                height="100%"
                width="100%"
                id="map"
                [center]="center"
                [zoom]="mapOptions.zoom"
                #map
                [options]="mapOptions"
                (mapDragend)="onMapDragEnd()"
                (zoomChanged)="onMapZoomChanged()"
            >
                @for (marker of markers; track $index) {
                    <map-marker
                        (mapClick)="clickMapMarker(somemarker, marker.index)"
                        #somemarker="mapMarker"
                        [position]="marker.position"
                        [options]="marker.option"
                    >
                    </map-marker>
                }
            </google-map>

            <!-- Détail de l'emplacement sélectionné -->
            @if (selectedMapScreens != null || isMapInfoLoading) {
                <div class="screenMapContainer" [@fadeInRight]>
                    <div class="listHeader">
                        <h3>{{ getNbScreens() }} Ecrans dans l'emplacement</h3>
                        <div id="expandRight" (click)="closeInfoWindow()">
                            <!-- Close Btn -->
                            <mat-icon>expand_less</mat-icon>
                        </div>
                    </div>
                    <div class="selectedScreens">
                        @if (!isMapInfoLoading) {
                            <!-- Wancom Screens -->
                            @if (selectedMapScreens?.wancoms != null) {
                                @for (screen of selectedMapScreens?.wancoms; track $index) {
                                    <app-screen-info
                                        class="mapScreenInfo"
                                        [face]="screen"
                                        [filterParams]="filterParams"
                                        [poweredFaceIds]="poweredFaceIds"
                                        (playlistOrderChanged)="updatePlaylistOrder($event)"
                                        (diffusionsDeleted)="deleteWancomDiffusion($event)"
                                        (diffForScreenDeleted)="
                                            deleteWncmDiffFormScreen($event.diffusion, $event.faceId)
                                        "
                                    ></app-screen-info>
                                }
                            }
                            <!-- Client Screens -->
                            @if (selectedMapScreens?.clients != null) {
                                @for (orga of selectedMapScreens?.clients; track $index) {
                                    @for (face of orga.faces; track $index) {
                                        <app-screen-info
                                            class="mapScreenInfo"
                                            [face]="face"
                                            [filterParams]="filterParams"
                                            [poweredFaceIds]="poweredFaceIds"
                                            (playlistOrderChanged)="updatePlaylistOrder($event)"
                                            (diffusionsDeleted)="deleteDiffusion($event)"
                                            (diffForScreenDeleted)="
                                                deleteDiffForScreen($event.diffusion, $event.faceId)
                                            "
                                        ></app-screen-info>
                                    }
                                }
                            }
                        } @else {
                            <mat-card>
                                <mat-card-content
                                    class="loaderCard"
                                    style="display: flex; flex-direction: column; align-items: center"
                                >
                                    <mat-spinner [diameter]="70"></mat-spinner>
                                    <p>Chargement des écrans ...</p>
                                </mat-card-content>
                            </mat-card>
                        }
                    </div>
                </div>
            }

            <!-- Liste des écrans -->
        </div>
    }
</div>
